import React, { FC } from 'react';
import { ActionButtonProps } from '@components/ncFileVersions/types';
import { Text, View } from 'react-native';
import { font } from '@styles/fonts';
import InputLine from '@components/machines/components/detailsComponents/activeMachine/components/InputLine';

interface ActionButtonExtraProps {
  testID?: string;
}

const ActionButton: FC<ActionButtonProps & ActionButtonExtraProps> = ({ loading, text, C, borderBottomRadius, borderTopRadius, action, testID }) => {
  const config = {
    borderBottomRadius,
    borderTopRadius,
    onlyLabel: false,
    isText: false,
    withoutArrow: true,
    rightSideTakesAllSpace: true,
    data: [{}],
    index: 0,
    i: {
      action,
      Component: () => {
        return (
          <View style={[{ flex: 1, justifyContent: 'center' }]}>
            <Text numberOfLines={1} style={[font.Body, { color: C('Link/Light/Primary') }]}>
              {text}
            </Text>
          </View>
        );
      },
    },
    C,
    loading,
    testID,
  };

  return <InputLine {...config} withoutStretchingForContainer />;
};

export default ActionButton;
